import getDateObjectFromDateStringOrDateObject from "./getDateObjectFromDateStringOrDateObject";
import { HotelCalendarState } from "../defs";
import { HscStoreState } from "../../hsc/defs";
import { HotelRoomState } from "../hotel-rooms";
import { HotelViewRoomDetailsState } from "../../view-room-details/defs";

export default function vuexUpdateCheckInDate<T extends HscStoreState | HotelRoomState | HotelViewRoomDetailsState>() {
  return async function (
    { state }: { state: HotelCalendarState & T },
    checkInDate: string | Date | null
  ): Promise<void>  {
    if (null === checkInDate) {
      state.checkInDate = null;
    } else {
      const newCheckInDate = getDateObjectFromDateStringOrDateObject(checkInDate);
      if (newCheckInDate) {
        if (null !== state.bookingLinkData) {
          state.bookingLinkData.start = newCheckInDate.getFullYear() + '-' +
            String(newCheckInDate.getMonth() + 1).padStart(2, '0') + '-' +
            String(newCheckInDate.getDate()).padStart(2, '0');
        }
        state.checkInDate = newCheckInDate;
      }
    }
  }
}